import Footer from 'components/organisms/Footer/GlobalFooter';
import HomeHeader from 'components/organisms/Header/HomeHeader';
import ProfileHeader from 'components/organisms/Header/ProfileHeader';
import * as React from 'react';
import Body from './ProfilePageBody';

const Profile = () => {
  const [currentTab, setCurrentTab] = React.useState<string>('Feed');
  const [editing, setEditing] = React.useState<boolean>(false);

  const handleEditing = () => {
    setEditing(!editing);
  };

  // const handleChange = (name: string, value: string) => {
  //   setFormData({ ...formData, [name]: value })
  // }

  return (
    <React.Fragment>
      <HomeHeader></HomeHeader>
      <ProfileHeader
        setCurrentTab={setCurrentTab}
        currentTab={currentTab}
        setEditing={handleEditing}
        editing={editing}
        // handleChange={handleChange}
      />
      <Body
        currentTab={currentTab}
        editing={editing}
        // handleChange={handleChange}
      />
      <Footer />
    </React.Fragment>
  );
};

export default Profile;
